import sourceLocale from 'antd/lib/locale/zh_CN'

import { merge } from 'lodash'

const zh_CN = merge({}, sourceLocale, {
  Table: {
    loadingDescription: '数据加载中...',
    emptyDescription: '暂无数据',
  },
  Empty: {
    noGraphData: '暂无图表',
    noPermission: '暂无权限',
    createdSuccessfully: '创建成功',
    creationFailed: '创建失败',
    noNetwork: '网络未连接',
    noData: '暂无数据',
  },
  Handle: {
    more: '更多',
  },
  Exception: {
    '403': '很抱歉，暂无该页面访问权限',
    '404': '很抱歉，本页暂无结果',
    '500': '很抱歉，服务器报错',
  },
  TntdCascader: {
    noDate: '暂无数据',
  },
  TntdSecondPage: {
    back: '返回',
  },
  ColorPicker: {},
})

export default zh_CN
